import React from 'react';
import { Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface StatusChipProps {
  displayType?: string;
  value: 0 | 1 | boolean;
  onClick?: () => void;
}

const StatusChip: React.FC<StatusChipProps> = ({ 
  displayType = 'icon', 
  value,
  onClick 
}) => {
  // Determine if value is truthy (1 or true) or falsy (0 or false)
  const isTruthy = value === 1 || value === true;
  
  // Determine variant: success for truthy, error for falsy
  const variant = isTruthy ? 'success' : 'error';
  
  // Determine icon or label based on displayType
  const icon = displayType === 'icon' 
    ? (isTruthy ? <CheckIcon /> : <CloseIcon />)
    : undefined;
  
  const label = isTruthy ? 'Yes' : 'No';

  return (
    <Chip 
      size="small"
      icon={icon}
      label={label}
      color={variant}
      variant="filled"
      onClick={onClick}
    />
  );
};

export default StatusChip;
